import { render } from "./PriceComponent.vue?vue&type=template&id=40709c08&scoped=true"
import script from "./PriceComponent.vue?vue&type=script&lang=js"
export * from "./PriceComponent.vue?vue&type=script&lang=js"

import "./PriceComponent.vue?vue&type=style&index=0&id=40709c08&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40709c08"]])

export default __exports__